module.exports = __webpack_public_path__ + "static/media/architecture.26925426.png";